import { downloadFile, format, mapPaginationParamsToServer } from "@/shared";

import { mapEmployeeFiltersToServer } from "./mappers/mapEmployeeFiltersToServer";

export const exportEmployees = async (paginationParams, filters) => {
    const fileName = `exported_employees_${format(
        new Date(),
        "dd_MM_yyyy-HH_mm"
    )}`;

    await downloadFile("/human/employee/export", fileName, {
        ...mapPaginationParamsToServer(paginationParams),
        ...mapEmployeeFiltersToServer(filters),
    });
};
